var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-comment" }, [
    _c(
      "div",
      {
        staticClass: "yxtbiz-comment__content",
        class: {
          "yxtbiz-comment__content--hover":
            _vm.limited && _vm.showLimitedType === "hover",
        },
      },
      [
        _c(
          "yxtf-input",
          {
            staticClass: "yxtbiz-comment__input",
            attrs: {
              disabled: _vm.disabled || _vm.limited,
              type: _vm.inputType,
              rows: _vm.row,
              resize: _vm.resize,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLength,
              "show-word-limit": "",
              autosize: _vm.autosize,
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          },
          [
            _c("template", { slot: "textlimit" }, [
              _c("span", { staticClass: "yxtbiz-comment__count" }, [
                _vm.minLength && _vm.content.length < _vm.minLength
                  ? _c("span", { staticClass: "mr8" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_comment_word_limit", [_vm.minLength])
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm.maxLength
                  ? _c(
                      "span",
                      {
                        class: {
                          "yxtbiz-comment__count--last":
                            _vm.maxLength - _vm.content.length <= 5,
                        },
                      },
                      [_vm._v(_vm._s(_vm.maxLength - _vm.content.length))]
                    )
                  : _vm._e(),
              ]),
            ]),
          ],
          2
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.limited,
                expression: "limited",
              },
            ],
            staticClass: "yxtbiz-comment__limited",
          },
          [_vm._t("limited")],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "yxtbiz-comment__sub" },
      [
        this.showRate
          ? _c(
              "div",
              {
                staticClass: "mr20 yxtbiz-comment__rate",
                class: { "yxtbiz-comment__rate--text": _vm.showRateText },
              },
              [
                _c(
                  "yxtf-row",
                  { attrs: { type: "flex", align: "middle" } },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.rateReadonly && _vm.rate
                            ? _vm.$t("pc_biz_comment_rated")
                            : _vm.$t("pc_biz_comment_rate_please")
                        )
                      ),
                    ]),
                    _c("yxtf-rate", {
                      attrs: {
                        disabled:
                          _vm.disabled || _vm.limited || _vm.rateReadonly,
                        "text-color": "#757575",
                        "show-text": _vm.showRateText,
                        texts: _vm.rateTexts,
                        "void-icon-class": "yxt-icon-star-on",
                        "void-color": "#d9d9d9",
                      },
                      model: {
                        value: _vm.rate,
                        callback: function ($$v) {
                          _vm.rate = $$v
                        },
                        expression: "rate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.showImages
          ? _c(
              "div",
              { staticClass: "mr20" },
              [
                _c("comment-images", {
                  ref: "commentImages",
                  attrs: {
                    projName: _vm.projName,
                    disabled: _vm.disabled || _vm.limited,
                    uploadOptions: _vm.uploadOptions,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.showAnonymous
          ? [
              _vm.isAnonymousComment === 2
                ? _c(
                    "div",
                    {
                      staticClass:
                        "mr20 yxtbiz-comment__anonymous hover-primary-6",
                    },
                    [
                      _c(
                        "yxtf-checkbox",
                        {
                          attrs: {
                            disabled: _vm.disabled || _vm.limited,
                            "true-label": 2,
                            "false-label": 0,
                          },
                          model: {
                            value: _vm.isAnonymous,
                            callback: function ($$v) {
                              _vm.isAnonymous = $$v
                            },
                            expression: "isAnonymous",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isReply
                                ? _vm.$t("pc_biz_comment_nickname_reply")
                                : _vm.$t("pc_biz_comment_nickname")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "mr20 yxtbiz-comment__anonymous hover-primary-6",
                    },
                    [
                      _c(
                        "yxtf-checkbox",
                        {
                          attrs: {
                            disabled: _vm.disabled || _vm.limited,
                            "true-label": 1,
                            "false-label": 0,
                          },
                          model: {
                            value: _vm.isAnonymous,
                            callback: function ($$v) {
                              _vm.isAnonymous = $$v
                            },
                            expression: "isAnonymous",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isReply
                                ? _vm.$t("pc_biz_comment_anonymous_reply")
                                : _vm.$t("pc_biz_comment_anonymous")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ]
          : _vm._e(),
        _c("div", { staticClass: "mr20" }, [_vm._t("functions")], 2),
        _c(
          "div",
          { staticClass: "yxtbiz-comment__submit" },
          [
            _vm.cancelBtn
              ? _c(
                  "yxtf-button",
                  {
                    attrs: { plain: "", disabled: _vm.disabled || _vm.limited },
                    on: { click: _vm.cancel },
                  },
                  [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel")))]
                )
              : _vm._e(),
            _c(
              "yxtf-button",
              {
                attrs: {
                  type: "primary",
                  disabled: _vm.submitDisabled,
                  loading: _vm.loading,
                },
                on: { click: _vm.submit },
              },
              [_vm._v(_vm._s(_vm.$t("pc_biz_comment_submit")))]
            ),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }